import { Indicator } from "@/components/ui/indicator";
import { getVideoScoreBand, getVideoScoreBandColor } from "@/features/reports/utils/get-video-score-band";

/* Prop Types */
interface VideoMetricRowProps {
  label: string;
  score: number;
}

/**
 * VideoMetricRow component
 *
 * Renders a single video sub-metric (Hook / Visual ease / Hold) as a label on the
 * left and a coloured dot + qualitative band on the right, mirroring MemoryEmotionIndicator.
 */
export const VideoMetricRow = ({ label, score }: VideoMetricRowProps) => {
  /* Render */
  return (
    <div className="grid grid-cols-[2fr_1fr] items-center justify-between gap-2 text-sm">
      <span className="text-sm text-base-content/60 font-semibold">{label}</span>
      <div className="flex items-center gap-4 justify-start">
        <Indicator color={getVideoScoreBandColor(score)} size="small" />
        <span className="font-semibold whitespace-nowrap">{getVideoScoreBand(score)}</span>
      </div>
    </div>
  );
};
